// extracted by mini-css-extract-plugin
module.exports = {"color1":"#cd324e","color2":"#183250","color3":"#4b6a8e","color4":"#2fa06a","color5":"#f05a23"};